export default __webpack_public_path__ + "static/media/05.ee5b0cd7.jpg";